// Define hotspot-buttons component
if (!customElements.get('multicolumn-slider')) {
  customElements.define(
    'multicolumn-slider',
    class MulticolumnCarousel extends HTMLElement {
      constructor() {
        super();
        this.swiperWrapper = this.querySelector('.swiper-wrapper');
        this.marqueeWrapper = this.querySelector('.marquee-wrapper');
      }

      connectedCallback() {
        this.initBasedOnDevice();
        window.addEventListener('resize', this.initBasedOnDevice.bind(this));
        if (this.marqueeWrapper) {
          this.marquee();
        }
      }

      initBasedOnDevice() {
        const pcSlider = this.getAttribute('pc-slider') === 'true';
        const mobileSlider = this.getAttribute('mobile-slider') === 'true';
        const screenWidth = window.innerWidth;

        const shouldInit =
          (screenWidth <= 749 && mobileSlider) ||
          (screenWidth > 749 && pcSlider);

        if (shouldInit && !this.swiperInstance) {
          this.initializeSwiper();
        } else if (!shouldInit && this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      initializeSwiper() {
        if (!window.Swiper) {
          const swiperScript = document.createElement('script');
          swiperScript.src =
            'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
          swiperScript.onload = () => this.initSwiperInstance();
          document.head.appendChild(swiperScript);
        } else {
          this.initSwiperInstance();
        }
      }

      initSwiperInstance() {
        const pcItems =
          parseFloat(
            this.swiperWrapper.getAttribute('data-carousel-item-pc'),
          ) || 3;
        const mobileItems =
          parseFloat(
            this.swiperWrapper.getAttribute('data-carousel-item-mobile'),
          ) || 1.5;

        const slidesPerColumn =
          parseFloat(this.swiperWrapper.getAttribute('slide-per-column')) ||
          null;
        const slidesPerGroup =
          parseFloat(this.swiperWrapper.getAttribute('slide-per-group')) ||
          null;

        const autoplayAttr = this.swiperWrapper.getAttribute('data-autoplay');
        const autoplayDelay =
          parseInt(this.swiperWrapper.getAttribute('data-speed')) || 3000;
        const autoplayLoop = this.swiperWrapper.getAttribute('data-loop');

        const autoplayEnabled = autoplayAttr === 'true' || autoplayAttr === '1';

        const mobileBreakpoint = {
          slidesPerView: mobileItems,
        };

        if (slidesPerGroup !== null) {
          mobileBreakpoint.slidesPerGroup = slidesPerGroup;
        }

        if (slidesPerColumn !== null) {
          mobileBreakpoint.slidesPerColumn = slidesPerColumn;
        }

        const isMobile = window.innerWidth < 750;

        const swiperConfig = {
          loop: autoplayLoop ? true : false,
          spaceBetween: 24,
          centeredSlides: isMobile,
          initialSlide: 0,
          scrollbar: {el: '.swiper-scrollbar', hide: true},
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            320: mobileBreakpoint,
            749: {slidesPerView: mobileItems + 1},
            1024: {slidesPerView: pcItems, centeredSlides: false},
          },
          on: {
            afterInit: (swiper) => {
              if (isMobile && swiper.activeIndex === 0) {
                swiper.wrapperEl.style.transform = 'translate3d(0px, 0, 0)';
              }
            },
            slideChangeTransitionStart: (swiper) => {
              if (isMobile && swiper.activeIndex === 1) {
                swiper.update();
              }
            },
          },
        };
        if (autoplayEnabled) {
          swiperConfig.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }

        this.swiperInstance = new Swiper(this, swiperConfig);
      }
      marquee() {
        const totalWidth = this.marqueeWrapper.scrollWidth;
        const speed = 200;
        const duration = totalWidth / speed;
        this.marqueeWrapper
          .querySelector('.marquee-items')
          .style.setProperty('animation-duration', `${duration}s`, 'important');
      }
    },
  );
}
// Define menu-banner-slider component
if (!customElements.get('menu-banner-slider')) {
  customElements.define(
    'menu-banner-slider',
    class MulticolumnCarousel extends HTMLElement {
      constructor() {
        super();
        this.swiperWrapper = this.querySelector('.swiper-wrapper');
      }

      connectedCallback() {
        this.initializeSwiper();
      }

      initializeSwiper() {
        if (!window.Swiper) {
          const swiperScript = document.createElement('script');
          swiperScript.src =
            'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
          swiperScript.onload = () => this.initSwiperInstance();
          document.head.appendChild(swiperScript);
        } else {
          this.initSwiperInstance();
        }
      }

      initSwiperInstance() {
        const pcItems =
          parseFloat(
            this.swiperWrapper.getAttribute('data-carousel-item-pc'),
          ) || 3;
        const mobileItems =
          parseFloat(
            this.swiperWrapper.getAttribute('data-carousel-item-mobile'),
          ) || 1.5;

        new Swiper(this, {
          loop: false,
          scrollbar: {
            el: '.swiper-scrollbar',
            hide: true,
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          slidesPerView: 3,
          spaceBetween: 16,
          breakpoints: {
            320: {slidesPerView: mobileItems},
            768: {slidesPerView: mobileItems},
            1024: {slidesPerView: pcItems},
          },
        });
      }
    },
  );
}
